<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <page-header :title="pageTitle" :subtitle="pageSubtitle" />

    <page-content>
      <rest-form
        ref="form"
        :save-endpoint="saveEndpoint"
        :after-save="afterSave"
        :model="model"
        :rules="rules"
        :disabled="readonly"
      >
        <slot name="form" :model="model"></slot>
      </rest-form>

      <div class="save-button" v-if="!readonly && !nosave">
        <el-button
          type="primary"
          icon="el-icon-check"
          @click="save()"
          :disabled="isDisabledSaveButton"
        >
          {{ $t(saveButtonTranslation()) }}
          <el-tooltip v-if="isDisabledSaveButton">
            <div
              style="text-align: center"
              slot="content"
              v-html="$t('RestForm_Save_Enabled_Tooltip')"
            />
            <span><i class="el-icon-warning-outline"></i></span>
          </el-tooltip>
        </el-button>
      </div>
    </page-content>
  </rest-page>
</template>

<script>
import PageHeader from '@/common/components/page/PageHeader'
import PageContent from '@/common/components/page/PageContent'
import RestPage from '@/common/components/rest/RestPage'
import RestForm from '@/common/components/rest/RestForm'

export default {
  name: 'RestFormPage',

  components: {
    PageHeader,
    PageContent,
    RestPage,
    RestForm
  },

  props: {
    fetchEndpoint: {
      type: [Object, Array, null],
      required: false
    },

    saveEndpoint: {
      type: Object,
      required: true
    },

    isDisabledSaveButton: {
      type: Boolean,
      required: false,
      default: false
    },

    afterSave: {
      type: Function,
      required: false
    },

    pageTitle: {
      type: String,
      required: true
    },

    pageSubtitle: {
      type: String,
      required: false
    },

    model: {
      required: true
    },

    rules: {
      type: Object,
      required: false
    },

    readonly: {
      type: Boolean,
      required: true,
      default: false
    },

    nosave: {
      type: Boolean,
      required: false,
      default: false
    },

    beforeSave: {
      type: Function
    }
  },

  methods: {
    save() {
      if (this.beforeSave) {
        this.beforeSave()
      }
      this.$refs['form'].save()
    },

    saveButtonTranslation() {
      return this.isDisabledSaveButton
        ? 'RestForm_Save_Enabled'
        : 'RestForm_Save'
    }
  }
}
</script>

<style scoped>
.save-button {
  margin: 20px 0;
  text-align: center;
}
>>> .save-button .el-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestFormPage.vue